/**
 * Finance dashboard inside the super admin console.
 *
 * Same component the portal admin console mounts at /admin/finance, wired to
 * the super admin's API client so requests carry the super_admin token instead
 * of a portal one. Sharing the component keeps the two consoles from drifting.
 *
 * The scope difference is resolved server-side, not here: require_analytics_admin
 * in app/routers/analytics.py hands the super admin a platform-wide (org_id
 * None) scope, while a tenant's org_admin hitting the same endpoints is pinned
 * to their own organization.
 */
import FinanceDashboardPage from "@/pages/FinanceDashboard";

import { superAdminApi } from "./session";

export default function SuperAdminFinancePage() {
  return <FinanceDashboardPage client={superAdminApi} />;
}
